import { AppProducts } from 'src/app/app.constants';
import { AdvancedDatasetFieldDto, AdvancedDatasetInputKind, AdvancedDatasetInputDto, AdvancedDatasetDto, ListVersionedProductDto, DatasetJoinType, JointDatasetFieldDto } from 'src/app/services/api.services';

//#region Global Filter
export enum GlobalFilterType {
  DatasetName = 'datasetName',
  FieldName = 'fieldName',
  InputParameter = 'inputParameter',
  All = 'all'
}

export interface GlobalFilterTypeOption {
  type: GlobalFilterType;
  title: string;
};

export const DefaultGlobalFilterTypeOptions: GlobalFilterTypeOption[] = [
  {
    type: GlobalFilterType.DatasetName,
    title: 'Datasets'
  },
  {
    type: GlobalFilterType.InputParameter,
    title: 'Controls/Filters'
  },
  {
    type: GlobalFilterType.FieldName,
    title: 'Fields'
  },
  /* INFO: IN-1723 not included as of 
  {
    type: GlobalFilterType.All,
    title: 'All'
  }
  */
];


export interface GlobalFilter {
  searchText: string;
  type: GlobalFilterType;
  limitToJoinableDatasets: boolean;
}

export interface GlobalFilterChangedArgs {
  globalFilter: GlobalFilter;
}

export const DefaultGlobalFilter: GlobalFilter = {
  searchText: '',
  type: GlobalFilterType.DatasetName,
  limitToJoinableDatasets: false
};
//#endregion

//#region Products
export interface Product {
  id: number;
  name: string;
  iconUrl: string;
  iconWidth: number;
  title: string;
  totalDatasets: number;
  visibleDatasets: number;
  datasetGroups: ProductDatasetGroup[];
  hidden?: boolean;
};

export interface ProductDatasetGroup {
  id: number;
  title: string;
  datasets: ProductDataset[];
  visibleDatasets: number;
  hidden?: boolean;
};

export interface ProductDataset {
  id: number;
  productInfo: ListVersionedProductDto;
  hidden?: boolean;
  template: AdvancedDatasetDto;

  used?: boolean;
  tabIndex?: number;
};
//#endregion

//#region Datasets
export interface DatasetTab {
  title?: string;
  datasetId?: number;
  datasetName?: string;
  datasetCategory?: string;
  invalid?: boolean;

  joinType?: JoinTypeOption;
  joinFields?: JointDatasetFieldDto[];
  joinFieldsPristine?: boolean;
};
//#endregion

//#region Controls/Filters
export interface DatasetInput {
  id: number;
  template: AdvancedDatasetInputDto;
  value?: any;
  label?: string;
  hidden?: boolean;
  defaultValue?: any;
  inputs?: DatasetInput[];
};

export interface DatasetInputGrouping {
  inputs?: DatasetInput[];
  helpText?: string;
  type?: string;
  title?: string;
};

export interface DatasetInputGroup {
  id: number;
  title: string;
  inputs: DatasetInput[];
  hidden?: boolean;
};

export interface DatasetInputChangeEventArgs {
  kind: AdvancedDatasetInputKind;
  inputId: number;
  changes: any;
};

export enum DatasetInputGroupLayout {
  OneColumn = 'oneColumn',
  TwoColumns = 'twoColumns'
};
//#endregion

//#region Fields
export interface DatasetField {
  id: number;
  field: AdvancedDatasetFieldDto;
  icon: string;
  hidden?: boolean;
  exclude?: boolean;
  udf?: boolean;
};

export const DefaultDatasetFieldIcon = 'fas fa-layer-group';
//#endregion

//#region Join Dialog
export interface JoinDialogModel {
  datasets: JoinDialogDataset[];
  selectedIndex: number;
};

export interface JoinDialogDatasetField {
  id: any;
  title: string;
}

export interface JoinDialogDataset {
  id: number;
  invalid: boolean;
  selected: boolean;
  title: string;
  product: string;
  fields: JoinDialogDatasetField[];
  joinType: JoinTypeOption;
  joinFields: JointDatasetFieldDto[];
};

export const JoinTypeIcons = [
  'assets/img/joins/inner.svg',
  'assets/img/joins/left-outer.svg',
  'assets/img/joins/right-outer.svg',
  'assets/img/joins/full-outer.svg',
];

export interface JoinTypeOption {
  id: DatasetJoinType;
  title: string;
  icon: string;
};

export const JoinTypeOptions: JoinTypeOption[] = [
  {
    id: DatasetJoinType.Inner,
    title: 'Inner',
    icon: JoinTypeIcons[DatasetJoinType.Inner]
  },
  {
    id: DatasetJoinType.LeftOuter,
    title: 'Left',
    icon: JoinTypeIcons[DatasetJoinType.LeftOuter]
  },
  {
    id: DatasetJoinType.RightOuter,
    title: 'Right',
    icon: JoinTypeIcons[DatasetJoinType.RightOuter]
  },
  {
    id: DatasetJoinType.FullOuter,
    title: 'Outer',
    icon: JoinTypeIcons[DatasetJoinType.FullOuter]
  }
];
//#endregion
